import styled from "styled-components";

import { DropdownItem } from "@similarweb/ui-components";

const TAG_WIDTH = 60;

export const StyledFormCheckboxDropdownItem = styled(DropdownItem)`
    overflow: hidden;
    width: 100%;
    padding: 8px 16px;
    height: auto;
    min-height: 42px;

    & > div {
        width: 100%;
        flex-direction: row-reverse;
        justify-content: space-between;
        gap: 8px;
        align-items: flex-start;

        & > div {
            margin-right: 0;
        }

        & > label {
            width: calc(100% - 32px);
        }
    }
`;

export const StyledFormDropdownItemTextWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding-top: 4px;
`;

export const StyledFormDropdownItemTitleWrapper = styled.div`
    max-width: calc(100% - ${TAG_WIDTH}px);
`;
